import React, { Component } from 'react';

import isFunction from 'lodash/isFunction';
import isEmpty from 'lodash/isEmpty';

import { inject, observer } from 'mobx-react';
import { Select, Icon } from 'antd';

import './AlimentationFilter.css';

@inject('translationsStore', 'carsStore')
@observer
export default class AlimentationFilter extends Component {
  constructor(props) {
    super(props);

    this.state = { visible: this.props.visible };
  }

  componentDidMount() {
    if (this.props.carsStore.filters) {
      this.init(this.props.carsStore.filters);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.status !== this.props.status && this.props.status === false) {
      this.reset();
    }
  }

  init(filters) {
    this.setState({ filters }, () => {
      this.initAlimentation();
    });
  }

  initAlimentation = () => {
    const alimentations = this.props.carsStore.filters.alimentations;

    this.setState({ alimentations });
  };

  selectAlimentation = alimentation => {
    this.setState({ alimentationSelected: alimentation });
    this.props.carsStore.appliedFilters.alimentation = alimentation;
  };

  reset = () => {
    if (isFunction(this.props.reset)) {
      this.props.apply();
    }
    if (this.props.reset !== false) {
      this.setState({
        alimentationSelected: null
      });
    }
  };
  render() {
    const { translationsStore, carsStore, status } = this.props;
    const { alimentationSelected } = this.state;

    return (
      <div className="AlimentationFilter" id="AlimentationFilter">
        <div className="filterTitle">
          {translationsStore.translate('advancedfilter.alimentation')}

          <span>
            {!isEmpty(alimentationSelected) && status !== false && (
              <span>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div className="selected">{translationsStore.translate(`alimentation.${alimentationSelected}`)}</div>
                  <Icon style={{ marginLeft: '5px' }} type="close-circle" onClick={this.reset} />
                </div>
              </span>
            )}
          </span>
        </div>
        <Select value={alimentationSelected} onChange={this.selectAlimentation}>
          {carsStore.filters.alimentations.map(alimentation => (
            <Select.Option value={alimentation} key={alimentation}>
              {translationsStore.translate(`alimentation.${alimentation}`)}
            </Select.Option>
          ))}
        </Select>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/GroupsManagerDashboard/CarAdvancedFilter/filters/AlimentationFilter/AlimentationFilter.js